import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { FavRowX } from '../components';

const List = styled.div`
  height: auto;
  overflow: scroll;
`;

const FavListX = ({ theme, coins }) => (
  <ThemeProvider theme={theme}>
    <List>{coins.map(coin => <FavRowX coin={coin} key={coin.id} />)}</List>
  </ThemeProvider>
);

export default withTheme(FavListX);



// WEBPACK FOOTER //
// ./src/components/FavListX.js